import * as viewer from '@grapecity/wijmo.viewer';
import * as wjInput from '@grapecity/wijmo.react.input';
import { PdfViewer } from '@grapecity/wijmo.react.viewer';
// import { PDFViewer } from '@react-pdf/renderer';
import { useState, useEffect } from 'react';

const PdfPreview = (props) => {
    const { pdf, viewMode = 1, mouseMode = 0, fullScreen = false, zoomFactor = 1 } = props;
    const [loaded, setLoaded] = useState(false);

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        setLoaded(false);
        setNumPages(null);
        setPageNumber(1);
    }, [pdf]);

    const handleSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setLoaded(true);
    };
    return loaded ? (
        <>
            {/* <PdfViewer
            filePath="PdfRoot/DefaultDocument.pdf"
            viewMode={viewMode}
            mouseMode={mouseMode}
            fullScreen={fullScreen}
            zoomFactor={zoomFactor}
            serviceUrl="https://developer.mescius.com/componentone/demos/aspnet/c1webapi/latest/api/pdf"
            style={{ width: '100%' }}
        /> */}
            <div>
                {/* <Document file="assets/Example.pdf.pdf" onLoadSuccess={handleSuccess}>
                    <Page pageNumber={pageNumber} />
                </Document> */}
                <p>
                    Page {pageNumber} of {numPages}
                </p>
            </div>
        </>
    ) : (
        <div>Loading...</div>
    );
};

export default PdfPreview;
